<template>
    <div>
        <b-modal id="template-edit" title="Edit template" :hide-footer="hideFooter">
            <form>
                <div class="form-group">
                  <label for="#cmpName">Template Name:</label>
                  <input class="form-control" type="text" placeholder="Ex: betnow" required="required" v-model="template.name">
                </div>
                <div class="form-group">
                  <label for="#cmpCode">Description:</label>
                  <textarea class="form-control" placeholder="Ex: Template description here ..." v-model="template.description"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">English content:</label>
                  <textarea class="form-control" placeholder="English content here!" v-model="template.gb_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Germany content:</label>
                  <textarea class="form-control" placeholder="Germany content here" v-model="template.de_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Denmark content:</label>
                  <textarea class="form-control" placeholder="Denmark content here!" v-model="template.dk_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Chinese content:</label>
                  <textarea class="form-control" placeholder="Chinese content here!" v-model="template.cn_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Romanian content:</label>
                  <textarea class="form-control" placeholder="Romanian content here!" v-model="template.ro_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Portuguese content:</label>
                  <textarea class="form-control" placeholder="Portuguese content here!" v-model="template.pt_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Spanish content:</label>
                  <textarea class="form-control" placeholder="Spanish content here!" v-model="template.es_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Italiano content:</label>
                  <textarea class="form-control" placeholder="Italiano content here!" v-model="template.it_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Hungarian content:</label>
                  <textarea class="form-control" placeholder="Hungarian content here!" v-model="template.hu_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Polish content:</label>
                  <textarea class="form-control" placeholder="Polish content here!" v-model="template.pl_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Czech content:</label>
                  <textarea class="form-control" placeholder="Czech content here!" v-model="template.cz_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Slovak content:</label>
                  <textarea class="form-control" placeholder="Slovak content here!" v-model="template.sk_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Holland content:</label>
                  <textarea class="form-control" placeholder="Holland content here!" v-model="template.nl_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Bulgary content:</label>
                  <textarea class="form-control" placeholder="Bulgary content here!" v-model="template.bg_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Swedish content:</label>
                  <textarea class="form-control" placeholder="Swedish content here!" v-model="template.sv_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Norvegian content:</label>
                  <textarea class="form-control" placeholder="Norvegian content here!" v-model="template.no_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Greek content:</label>
                  <textarea class="form-control" placeholder="Greek content here!" v-model="template.gr_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Russian content:</label>
                  <textarea class="form-control" placeholder="Russian content here!" v-model="template.ru_content"></textarea>
                </div>
                <div class="form-group">
                  <label class="text-info">Estonian content:</label>
                  <textarea class="form-control" placeholder="Estonian content here!" v-model="template.et_content"></textarea>
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-secondary form-control" @click.prevent="updateTemplate">Update</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      template: {}
    }
  },
  methods: {
    updateTemplate () {
      if (this.template.name && this.template.gb_content) {
        const formData = new FormData()
        formData.append('name', this.template.name)
        formData.append('description', this.template.description)
        formData.append('gb_content', this.template.gb_content)
        formData.append('de_content', this.template.de_content)
        formData.append('dk_content', this.template.dk_content)
        formData.append('no_content', this.template.no_content)
        formData.append('cn_content', this.template.cn_content)
        formData.append('ro_content', this.template.ro_content)
        formData.append('es_content', this.template.es_content)
        formData.append('it_content', this.template.it_content)
        formData.append('hu_content', this.template.hu_content)
        formData.append('pl_content', this.template.pl_content)
        formData.append('cz_content', this.template.cz_content)
        formData.append('sk_content', this.template.sk_content)
        formData.append('pt_content', this.template.pt_content)
        formData.append('nl_content', this.template.nl_content)
        formData.append('bg_content', this.template.bg_content)
        formData.append('sv_content', this.template.sv_content)
        formData.append('gr_content', this.template.gr_content)
        formData.append('ru_content', this.template.ru_content)
        formData.append('et_content', this.template.et_content)

        this.$http.patch(`${this.$api_url}/template/edit/` + this.template._id, formData).then((success, error) => {
          if (success) {
            Bus.$emit('templateUpdated', success.data)
            this.$bvModal.hide('template-edit')
          }
          if (error) {
            this.$bvModal.hide('template-edit')
            alert('Something wrong just happened!')
          }
        })
      }
    }
  },
  created () {
    Bus.$on('editTemplate', (templateData) => {
      this.template = templateData
    })
  },
  beforeDestroy () {
    Bus.$off('editTemplate')
  }
}
</script>
<style scoped>
</style>
